import { AgencyStatus, AgencyTeam, AgencyType } from '../interfaces/types';

export const AGENCY_TEAM_OPTIONS = [
  {
    value: AgencyTeam.ONE_TO_THIRTY_FIELD,
    label: 'Field 1-30'
  },
  {
    value: AgencyTeam.THIRTY_PLUS_FIELD,
    label: 'Field 30+'
  },
  {
    value: AgencyTeam.OTHER,
    label: 'Others'
  }
];

export const AGENCY_TEAM_OPTIONS_MAP = {
  [AgencyTeam.ONE_TO_THIRTY_FIELD]: 'Field 1-30',
  [AgencyTeam.THIRTY_PLUS_FIELD]: 'Field 30+',
  [AgencyTeam.OTHER]: 'Others'
};

export const AGENCY_STATUS_OPTIONS = [
  {
    value: AgencyStatus.ACTIVE,
    label: 'Active'
  },
  {
    value: AgencyStatus.INACTIVE,
    label: 'Inactive'
  },
  {
    value: AgencyStatus.TERMINATED,
    label: 'Terminated'
  }
];

export const tabOptions = [
  { label: 'No', value: false },
  { label: 'Yes', value: true }
];

export const MIN_SEARCH_VALUE_LIMIT = 3;
